export default class Common {
  public static mobileRegex() {
    return /^[6-9]+([0-9]*)$/;
  }

  public static rolesManage():any {
    return {
      admin: 'AgAdmin',
      aguser:'AgUser',
      adminview:'AgViewer',
      client: 'ClientAdmin',
      clientview: 'ClientViewer',
      clientusr: 'ClientUser',
      center: 'CenterAdmin',
      centerview:'CenterViewer',
      centerusr:'CenterUser',
      seedprocessingoperator: 'SeedProcessingOperator'     
    };
  }


  public static roleList(): any {
    return [
      // { text: "AGADMIN", value: "AG ADMIN" },
      { value: "AGUSER", text: "AG USER" },
      { value: "AGVIEWER", text: "AG VIEWER" },
      { value: "CLIENTADMIN", text: "NHRDF ADMIN" },
      { value: "CLIENTUSER", text: "NHRDF USER" },
      { value: "CLIENTVIEWER", text: "NHRDF VIEWER" },
      { value: "CENTERADMIN", text: "CENTER ADMIN" },
      { value: "CENTERUSER", text: "CENTER USER" },
      { value: "CENTERVIEWER", text: "CENTER VIEWER" },
      { value: "AGADMIN", text: "AG ADMIN" },
      { value: "SEEDPROCESSINGOPERATOR", text: "SEED PROCESSING OPERATOR"}

      // { text: "WAREHOUSEADMIN", value: "WAREHOUSE ADMIN" },
      // { text: "WAREHOUSEUSER", value: "WAREHOUSE USER" },
      // { text: "WAREHOUSEVIEWER", value: "WAREHOUSE VIEWER" },
      // { text: "ACCOUNTANT", value: "ACCOUNTANT" },

      // { text: "FARMER", value: "FARMER" },
      // { text: "GRADEADMIN", value: "GRADE ADMIN" },
      // { text: "GRADEUSER", value: "GRADE USER" }
    ]
  }

  public static userLogin() {
    return JSON.parse(sessionStorage.getItem('user') || '{}');
  }
  public static icon(val: string) {
    const iconMap: Record<string, string> = {
      edit: 'edit',
      edit_Land: 'bookmark',
      view: 'remove_red_eye',
      delete: 'delete',
      status: 'toggle_on',
      add_land:'note_add',
      edit_nominee:'edit',
      edit_witness:'edit',
      start_sampling:'science'
    };
    return iconMap[val] || 'help_outline'; // fallback icon
  }
  public static formDataArray(payloads: any) {
    const formData = new FormData();

    // Append each key-value pair from payloads
    for (const key in payloads) {
      if (payloads.hasOwnProperty(key)) {
        const value = payloads[key];
        const uppercasedValue =
          typeof value === 'string' ? value.toUpperCase() : value;
        formData.append(key, uppercasedValue);
      }
    }
    return formData;
  }

  public static formDataArrayWithout(payloads: any) {
    const formData = new FormData();

    // Append each key-value pair from payloads
    for (const key in payloads) {
      if (payloads.hasOwnProperty(key)) {
        const value = payloads[key];
        const uppercasedValue = value;
        formData.append(key, uppercasedValue);
      }
    }
    return formData;
  }


  public static formData2(
    payload: any,
    formData: FormData = new FormData(),
    parentKey: string = ''
  ): FormData {
    for (const key in payload) {
      if (payload.hasOwnProperty(key)) {
        const value = payload[key];
        let fullKey = '';

        if (parentKey) {
          if (Array.isArray(payload)) {
            // ✅ Array items like LandDetails[0].field
            fullKey = `${parentKey}[${key}]`;
          } else {
            // ✅ Nested object like LandDetails[0].Number
            fullKey = `${parentKey}.${key}`;
          }
        } else {
          fullKey = key;
        }

        if (value instanceof File || value instanceof Blob) {
          // ✅ Handle files
          formData.append(fullKey, value);
        } else if (Array.isArray(value)) {
          // ✅ Recurse into arrays
          value.forEach((item, index) => {
            this.formData2(item, formData, `${fullKey}[${index}]`);
          });
        } else if (value !== null && typeof value === 'object') {
          // ✅ Recurse into objects
          this.formData2(value, formData, fullKey);
        } else {
          // ✅ Append primitives (UPPERCASE if string)
          const finalValue = typeof value === 'string' ? value.toUpperCase() : value;
          formData.append(fullKey, finalValue as any);
        }
      }
    }
    return formData;
  }





  public static getStatus(type: any) {
    if (type == 'OK' || type == 'ok') {
      return true;
    } else {
      return false;
    }
  }

  public static scrollUp() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  public static errorMessage() {

    return {
      failed: "Unauthorized access. Your session may have expired. Please log in again."
    }

  }

  public static getDownloadAPI(){
    return{
      commodity:'commodity/commodity/list/csv/download?ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED&IsActive=true&IsActive=false',
      commoditytype:'commoditytypes/list/csv/download?ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED&IsActive=true&IsActive=false',
      variety:'variety/variety/list/csv/download?ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED&IsActive=true&IsActive=false',
      year: 'season/list/csv/download?ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED&IsActive=true&IsActive=false',
      season:'subseason/list/csv/download?ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED',
      center:'group/group/list/csv/download?GroupType=CENTER&GroupBy=CENTER&ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED&IsActive=true&IsActive=false',
      warehouse:'warehouse/list/csv/download?WareHouseType=CA&WareHouseType=NORMAL&GroupBy=CENTER&ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED&IsActive=true&IsActive=false',
      farmer:'farmer/farmer/list/csv/download?GroupType=CENTER&GroupBy=CLIENT&ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED&IsActive=true&IsActive=false',
      targetAllotment:'center/target/list/csv/download?GroupBy=CLIENT&GroupBy=CENTER&ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED&IsActive=true&IsActive=false',
      assayer:'user/list/csv/download?UserType=GRADEUSER&UserType=CENTERADMIN&ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED&IsActive=true&IsActive=false',
      agriInput:'farmer/distribution/list/csv/download?GroupBy=CLIENT&GroupBy=CENTER&ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED&IsActive=true&IsActive=false',
      targetAssignFarmer:'target/assign/farmer/list/csv/download?GroupBy=CLIENT&GroupBy=CENTER&ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED&IsActive=true&IsActive=false',
      userList:'user/list/csv/download?Role=CLIENTADMIN&Role=CENTERADMIN&Role=AGUSER&Role=AGVIEWER&Role=CLIENTUSER&Role=CLIENTVIEWER&Role=CENTERUSER&Role=CENTERVIEWER&Role=WAREHOUSEADMIN&Role=WAREHOUSEUSER&Role=WAREHOUSEVIEWER&Role=ACCOUNTANT&ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED&IsActive=true&IsActive=false',
      bag:'bag/list/csv/download?ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED&IsActive=true&IsActive=false',
      classofseed:'class/seed/list/excel/download?ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED&IsActive=true&IsActive=false',
      agreement:'agreement/list/excel/download?ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED&IsActive=true&IsActive=false',
      inspection:'inspection/list/csv/download?ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED&IsActive=true&IsActive=false'
    }
  }


  public static roleManage(type: any){
    if(this.userLogin()?.role == type){
      return true
    }
    return false
  }

   public static getChangedValues(newValue: any, oldValue: any): any {
  let changes: any = {};
  for (let key in newValue) {
    if (newValue.hasOwnProperty(key)) {
      if (newValue[key] !== oldValue[key]) {
        changes[key] = newValue[key]; // only include changed ones
      }
    }
  }
  return changes;
}

public static viewerUser(roles:any){
  return   roles.some((role:any) => role.includes('Viewer') && this.userLogin()?.role == role)
}
}
